export const LOCALES = ['en', 'zh-CN', 'zh-TW'];
export const DEFAULT_LOCALES = 'en';

export const LOCALES_MAPPING = {
  'en': 'en',
  'zh': 'zh-CN',
  'zh-CN': 'zh-CN',
  'zh-TW': 'zh-TW',
  'zh-HK': 'zh-TW',
}; 
